<div class="invitation-deleted">
    <div class="invitation-deleted__image">
        <img src="/assets/images/invitations/invitation-deleted.svg" [alt]="'Invitation expiree' | transloco">
    </div>
    <div [ngSwitch]="state" class="invitation-deleted__content">
        <div *ngSwitchCase="eInvitation.PartnerCustomer">
            <h3 class="invitation-content__title">{{'Le lien de l\'invitation a malheureusement expire...' | transloco}}
            </h3>
            <p 
            class="invitation-content__text" 
            [innerHTML]="'Le lien de l\'invitation a ete supprime. Veuillez contacter l\'administrateur de l\'organisation <strong>$name$</strong> pour en connaitre les raisons...'  | transloco:{ name: invitation.account.organization_name | escapeHtml}">
            </p>
        </div>
        <div class="invitation-content__actions">
            <a href="https://infomaniak.com"
            mat-flat-button
            color="primary">
             <span>{{ 'Acceder au site infomaniak' | transloco }}</span>
         </a>
        </div>
    </div>
</div>
